import { Box, Button } from "../../../../../../mads";
import { ChevronRight } from "../../../../../../mads/icons";

import { spacing, colors } from "@indeed/ifl-tokens/react-native";
import React from "react";
import { StyleSheet } from "react-native";

export interface LinkButtonProps {
  /**
   * The text to display in the link button
   */
  text: string;
  /**
   * Handler called when the button is pressed
   */
  onPress: () => void;
  /**
   * [web] If present, renders the button as an anchor tag for a11y
   */
  href?: string;
  /**
   * [web] Attributes for the anchor tag (e.g. { target: '_blank' })
   */
  hrefAttrs?: {
    download?: boolean;
    rel?: string;
    target?: string;
  };
  /**
   * Optional additional styles for the container
   */
  containerStyle?: any;
  /**
   * Optional additional styles for the text container
   */
  textContainerStyle?: any;
}

/**
 * A link button component with chevron icon, rendered inside a full-width bordered row.
 * Uses MADS Button internally for proper a11y (renders as <a> on web when href is provided).
 */
export function LinkButton({
  text,
  onPress,
  href,
  hrefAttrs,
  containerStyle,
  textContainerStyle,
}: LinkButtonProps) {
  return (
    <Box sx={[styles.container, containerStyle]}>
      <Box sx={[styles.textContainer, textContainerStyle]}>
        <Button
          variant="text"
          onPress={onPress}
          href={href}
          hrefAttrs={hrefAttrs}
          iconAfter={<ChevronRight size="sm" />}
        >
          {text}
        </Button>
      </Box>
    </Box>
  );
}

const styles = StyleSheet.create({
  container: {
    marginVertical: 0,
    marginHorizontal: -spacing.s4,
    minHeight: 44,
  },
  textContainer: {
    width: "100%",
    borderTopWidth: 1,
    borderBottomWidth: 1,
    borderTopColor: colors.borderWeak,
    borderBottomColor: colors.borderWeak,
    marginTop: spacing.s6,
    marginBottom: spacing.s2,
  },
});
